export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UsersPanel.vue?vue&type=template&id=107647fc&"


//////////////////
// WEBPACK FOOTER
// ./src/views/users/UsersPanel.vue?vue&type=template&id=107647fc&
// module id = 1428
// module chunks = 0